import React from 'react';

interface StyledCardProps {
  children: React.ReactNode;
  className?: string;
}

export const StyledCard: React.FC<StyledCardProps> = ({
  children,
  className = '',
}) => (
  <div
    className={`rounded-xl border border-gray-100 bg-white p-6 shadow-sm hover:border-[#FF732E]/10 dark:border-gray-800 dark:bg-gray-900 ${className}`}
  >
    {children}
  </div>
);

export const PrimaryButton: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ children, className = '', ...props }) => (
  <button
    className={`transform rounded-lg bg-[#FF732E] px-5 py-2.5 text-sm font-medium text-white transition-all duration-200 hover:bg-[#E65A1F] hover:shadow-md hover:shadow-[#FF732E]/10 focus:ring-2 focus:ring-[#FF732E]/50 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 ${className} `}
    {...props}
  >
    {children}
  </button>
);

export const SecondaryButton: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ children, className = '', ...props }) => (
  <button
    className={`transform rounded-lg border border-[#FF732E] bg-white px-5 py-2.5 text-sm font-medium text-[#FF732E] transition-all duration-200 hover:shadow-sm focus:ring-2 focus:ring-[#FF732E]/50 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 dark:bg-gray-900 ${className} `}
    {...props}
  >
    {children}
  </button>
);

export const StepHeading: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <h2 className="mb-3 text-2xl leading-tight font-semibold text-gray-900 dark:text-gray-100">
    {children}
  </h2>
);

export const StepDescription: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <p className="mb-6 text-base text-gray-600 dark:text-gray-400">{children}</p>
);

export const IconWrapper: React.FC<{
  children: React.ReactNode;
  color?: string;
}> = ({ children, color = 'bg-[#FF732E]' }) => (
  <div
    className={` ${color}/10 mb-4 flex h-12 w-12 items-center justify-center rounded-full p-3 transition-transform duration-200 hover:scale-105`}
  >
    <span className="text-2xl leading-tight">{children}</span>
  </div>
);

export const ProgressBar: React.FC<{ progress: number }> = ({ progress }) => (
  <div className="h-0.5 w-full overflow-hidden rounded-full bg-gray-100 dark:bg-gray-800">
    <div
      className="h-full bg-[#FF732E] transition-all duration-500 ease-out"
      style={{ width: `${progress}%` }}
    />
  </div>
);
